// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx -- The landing page is untranslated, English-only
   static HTML that deliberately sits outside the Smartling pipeline. Its tab title and iframe label
   are literals so this temporary page doesn't add strings for translation (and doesn't leave any
   behind when it's removed). */
import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { Title } from "#/services/page-title/Title"

/**
 * TEMPORARY (CONAPP-155): static distribution landing page shown at `/consumer`.
 *
 * The page is a standalone HTML document (`public/consumer-landing.html`) with its own reset
 * (`* { margin: 0 }`, `body { ... }`), its own fonts, and inline scripts driving the plan toggle,
 * the HSA/FSA calculator, and the FAQ accordion. It is framed rather than inlined into the SPA
 * because that keeps all of the above out of the carotene-styled app: React's
 * `dangerouslySetInnerHTML` would leak the global CSS and silently never run the inline scripts.
 *
 * The frame is same-origin, so links out of the page work via `target="_top"` (they full-page
 * navigate the SPA) and its `#pricing` / `#included` anchors scroll inside the frame as usual.
 *
 * To remove the page — three deletes, nothing else references it:
 *   1. `public/consumer-landing.html`
 *   2. this directory (`src/pages/consumer-landing/`)
 *   3. in `src/components/views/Root.tsx`, the `ConsumerLandingPage` import and its
 *      `<Route exact path="/consumer">` block. `/consumer` then resolves to the consumer package's
 *      `ConsumerRouter` again, exactly as it did before.
 */
export default function ConsumerLandingPage(): JSX.Element {
  return (
    <>
      <Title title="Fertility care" />
      {/* The landing page is the whole surface at `/consumer`, so the frame fills the viewport and
          `fixed` keeps it flush regardless of any layout the host renders around it. The scrolling
          wrapper is the long-standing iOS Safari workaround: older iOS expands a framed document to
          its full content height instead of scrolling it, which would clip everything below the
          fold with no way to reach it. */}
      <Box sx={{ position: "fixed", inset: 0, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
        <Box
          component="iframe"
          src="/consumer-landing.html"
          title="Carrot fertility care — HealthEquity Marketplace"
          sx={{ inlineSize: "100%", blockSize: "100%", border: "none", display: "block" }}
        />
      </Box>
    </>
  )
}
